import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useCallback } from 'react';

const useScrollToSection = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll helper function
  const scroll = (id) => {
    const element = document.getElementById(id);
    const navbar = document.getElementById('app-bar');

    if (element) {
      const navbarHeight = navbar?.offsetHeight || 0;
      const y = element.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  // Function returned to trigger scroll/navigation
  const scrollToSection = useCallback(
    (id) => {
      if (location.pathname !== '/') {
        // Save the id so we can scroll after navigation
        sessionStorage.setItem('scrollToId', id);
        navigate('/');
      } else {
        scroll(id);
      }
    },
    [location.pathname, navigate]
  );

  // On location change, check if there's a stored id to scroll to
  useEffect(() => {
    if (location.pathname === '/') {
      const id = sessionStorage.getItem('scrollToId');
      if (id) {
        scroll(id);
        sessionStorage.removeItem('scrollToId');
      }
    }
  }, [location.pathname]);

  return scrollToSection;
};

export default useScrollToSection;